import { render, staticRenderFns } from "./bgdRecharge.vue?vue&type=template&id=1a97c2c0&scoped=true&"
import script from "./bgdRecharge.vue?vue&type=script&lang=js&"
export * from "./bgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97c2c0",
  null
  
)

export default component.exports